import { combineReducers } from 'redux'
import totalCount from './totalCount'

export default combineReducers({
  totalCount,
})
